module.exports = __webpack_public_path__ + "static/media/Lioness_Logo_Black_400.b6b51ca6.png";